import { render } from "./Lex.vue?vue&type=template&id=63a9dd88"
import script from "./Lex.vue?vue&type=script&lang=js"
export * from "./Lex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__